import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';

@Component({
    selector: 'search-select-field',
    templateUrl: 'search-select-field.template.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SearchSelectFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => SearchSelectFieldComponent), multi: true }
    ]
})
export class SearchSelectFieldComponent extends AbstractFieldClass {
    @Input() title = '';
    @Input() tooltipText = '';
    @Input() optionTitleKey = 'optionText';
    @Input() data: {value: string|number, optionText: string}[] = [];
    @Input('class') valueClass = '';
    @Input() iconClass = '';
    @Input() withOther = false;
    @Input() other = '';

    constructor() {
        super();
    }

    getValueById(id: any): any {
        if (id === null) return false;

        let selectedItem;

        if (this.data && this.data.length) {
            selectedItem = this.data.find((elem) => {

                return +elem.value === +id;
            });
        }

        return (selectedItem) ? selectedItem[this.optionTitleKey] : false;
    }

    public validator(value): boolean {
        return true;
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/search-select-field/search-select-field.component.ts